import { render, staticRenderFns } from "./ModalKonfirmasiAngsuranSaja.vue?vue&type=template&id=430c4434&"
import script from "./ModalKonfirmasiAngsuranSaja.vue?vue&type=script&lang=js&"
export * from "./ModalKonfirmasiAngsuranSaja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports